import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AplicacionVersionFormComponent } from './form/aplicacion-version-form.component';
import { AplicacionVersionListComponent } from './list/aplicacion-version-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'src/app/custom-components/dialog/dialog.module';
import { MaterialModule } from 'src/app/material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomHeaderModule } from 'src/app/custom-components/custom-header/custom-header.module';
import {AplicacionVersionRoutingModule} from './aplicacion-version-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {AplicacionVersionService} from './aplicacion-version.service';
import { RouterModule } from '@angular/router';
import { AplicacionService } from '../aplicacion/aplicacion.service';




@NgModule({
  declarations: [
    AplicacionVersionFormComponent,
    AplicacionVersionListComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    MaterialModule,
    CustomHeaderModule,
    FlexLayoutModule,
    AplicacionVersionRoutingModule,
    RouterModule,
    SharedModule,
  ],
  providers: [AplicacionService,AplicacionVersionService]
})
export class AplicacionVersionModule { }
